import React, { useContext } from "react";
import { ReactComponent as Education } from "../assets/svg/education.svg";
import { ReactComponent as User } from "../assets/svg/user.svg";
import { ReactComponent as Phone } from "../assets/svg/phone.svg";
import { ReactComponent as Binary } from "../assets/svg/binary.svg";
import { ReactComponent as Close } from "../assets/svg/close.svg";
import styled, { keyframes } from "styled-components";
import { UserContext } from "../contexts/UserContext";
import { Link } from "react-router-dom";
import UserAPI from "../apis/UserAPI";

const Menu = ({ onClose = () => {} }) => {
  const userContext = useContext(UserContext);
  return (
    <Container onClick={() => onClose()}>
      <MenuStyled onClick={(e) => e.stopPropagation()}>
        <CloseIcon as={Close} onClick={() => onClose()} />
        <Header>
          <CollegueIcon as={Education} />
          {userContext.name !== undefined &&
          userContext.lastname !== undefined ? (
            <FullName>{`${userContext.name} ${userContext.lastname}`}</FullName>
          ) : (
            <FullName>{userContext.email}</FullName>
          )}
        </Header>
        <Options>
          <Option as={Link} to="/profile" delay={0}>
            <Icon as={User} />
            Mis datos
          </Option>
          <Option as={Link} to="/activation" delay={0.15}>
            <Icon as={Binary} />
            Código de activación
          </Option>
          <Option as={Link} to="/contact" delay={0.3}>
            <Icon as={Phone} />
            Contacto
          </Option>
          <Option delay={0.45} onClick={() => UserAPI.logout()}>
            <Icon />
            Cerrar sesión
          </Option>
        </Options>
      </MenuStyled>
    </Container>
  );
};

const Container = styled.div`
  z-index: 10;
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  top: 0;
`;

const CloseIcon = styled.div`
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
  padding: 10px;
  cursor: pointer;
  fill: rgba(0, 0, 0, 0.2);
  margin: 0 5px 0 auto;
`;

const option = keyframes`
    from {
      opacity: 0;
      transform: translateX(-50px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
`;

const menu = keyframes`
    from {
        opacity: 0;
        transform: translateX(-100%);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
`;

const MenuStyled = styled.div`
  max-width: 400px;
  width: 100vw;
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: white;
  padding: 10px 5px;
  box-sizing: border-box;
  box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.2);
  animation: ${menu} 0.3s forwards;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 10px;
`;

const CollegueIcon = styled.div`
  width: 30px;
  height: 30px;
  min-width: 30px;
  min-height: 30px;
  margin-right: 15px;
`;

const Icon = styled.div`
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
  margin: 5px 10px 5px 5px;
  fill: rgba(0, 0, 0, 0.4);
`;

const FullName = styled.div`
  font-size: 0.9em;
  font-weight: 600;
`;

const Options = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 10px;
`;

const Option = styled.div`
  width: 100%;
  padding: 10px;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  box-sizing: border-box;
  font-size: 0.9em;
  display: flex;
  align-items: center;
  opacity: 0;
  cursor: pointer;
  color: black;

  &:not(:last-child) {
    margin-bottom: 10px;
  }

  animation: ${option} 0.6s forwards ${(props) => `${props.delay || 0}s`};
`;

export default Menu;
